module.exports = __webpack_public_path__ + "img/marius.6e2b15c4.png";